module.exports = __webpack_public_path__ + "static/img/082.40e9367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/082.png
// module id = oIky
// module chunks = 0